// src/hooks/useAuth.js
import { useState, useEffect, createContext, useContext } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [blocked, setBlocked] = useState(null);

  useEffect(() => {
    fetch("/api/me")
      .then(r => r.json().then(d => ({ ok: r.ok, status: r.status, data: d })))
      .then(({ ok, status, data }) => {
        if (ok && data?.email) {
          setUser(data);
        } else if (status === 403 && data?.error === "access_denied") {
          setBlocked(data.message || "You are not authorised to access this portal.");
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function logout() {
    await fetch("/api/auth/logout", { method: "POST" });
    if (user?.isExternal) {
      window.location.href = "/";
    } else {
      window.location.href = "/.auth/logout?post_logout_redirect_uri=/";
    }
  }

  return (
    <AuthContext.Provider value={{ user, loading, blocked, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
